export default "__VITE_ASSET__DcCjHpJ5__"